export default __webpack_public_path__ + "static/media/target-10@2x.459b6a68.png";